































import { ref, defineComponent, PropType, watch } from '@vue/composition-api';
export default defineComponent({
  props: {
    // 选项（支持任意对象数组，通过optionClassName映射字段）
    selectOptions: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 是否禁用
    size: {
      type: String,
      default: 'medium',
    },
    // 已选中选项
    mulSelected: {
      type: Array as PropType<(string | number)[]>,
      default: () => [],
    },
    mulSelectLoading: {
      type: Boolean,
      default: false,
    },
    collapseTags: {
      type: Boolean,
      default: true,
    },
    selectAllClassName: {
      type: Object,
      default: () => ({
        label: '全部',
        value: '',
      }),
    },
    optionClassName: {
      type: Object,
      default: () => ({
        label: 'departmentName',
        value: 'departmentId',
      }),
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    disableAutoSelectAll: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const selectedArr = ref<(string | number)[]>([]);

    const selectAll = () => {
      const selectedArrValue = selectedArr.value;
      const { selectOptions, selectAllClassName, optionClassName } = props;
      if (selectedArrValue.length < selectOptions.length) {
        selectedArr.value = [];
        selectOptions.forEach((item) => {
          selectedArr.value.push(item[optionClassName.value]);
        });
        selectedArr.value.unshift(selectAllClassName.value);
      } else {
        // 取消全选
        selectedArr.value = [];
      }
      emit('updateMultipleSelect', selectedArr.value);
    };

    const changeSelect = (val: (string | number)[]) => {
      const { selectOptions, selectAllClassName } = props;
      if (!val.includes(selectAllClassName.value) && val.length === selectOptions.length) {
        selectedArr.value.unshift(selectAllClassName.value);
      } else if (val.includes(selectAllClassName.value) && val.length - 1 < selectOptions.length) {
        selectedArr.value = selectedArr.value.filter(item => item !== selectAllClassName.value);
      }
      emit('updateMultipleSelect', selectedArr.value);
    };

    const removeTag = (val) => {
      const { selectAllClassName } = props;
      if (val === selectAllClassName.value) {
        selectedArr.value = [];
        emit('updateMultipleSelect', selectedArr.value);
      }
    };

    watch(
      () => props.mulSelected,
      (newVal: (string | number)[]) => {
        selectedArr.value = [...newVal];

        const { selectAllClassName, selectOptions } = props;
        if (
          !selectedArr.value.includes(selectAllClassName.value)
          && selectedArr.value.length
          && selectedArr.value.length === selectOptions.length
        ) {
          selectedArr.value.unshift(selectAllClassName.value);
          if (!props.disableAutoSelectAll) {
            emit('updateMultipleSelect', selectedArr.value);
          }
        }
      },
      { immediate: true },
    );

    const load = () => {
      emit('load');
    };

    return {
      selectedArr,
      load,
      selectAll,
      changeSelect,
      removeTag,
    };
  },
});
